
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import i1 from '../assets/c1.png'
import i2 from '../assets/c2.png'
import i3 from '../assets/c3.png'
import i4 from '../assets/c4.png'
import i5 from '../assets/c5.png'
import i6 from '../assets/c6.png'
import i7 from '../assets/certificate7.png'
import i8 from '../assets/c8.png'
import i9 from '../assets/c9.png'
import i10 from '../assets/Certificate8.png'


const certificates = [
  { id: 1, cert: i1, title: 'Certificate 2' },
  { id: 2, cert: i2, title: 'Certificate 3' },
  { id: 3, cert: i3, title: 'Certificate 4' },
  { id: 4, cert: i4, title: 'Certificate 5' },
  { id: 5, cert: i6, title: 'Certificate 6' },
  { id: 6, cert: i7, title: 'Certificate 7' },
  { id: 7, cert: i8, title: 'Certificate 8' },
 { id: 8, cert: i9, title: 'Certificate 9' },
 { id: 9, cert: i10, title: 'Certificate 10' },
 
];

const Certificates = () => {
  return (
    <Container>
      <Row>
        {certificates.map((certif) => (
          <Col key={certif.id} sm={12} md={6} lg={4} className="mb-4" style={{ backgroundColor: "var(--green)" ,marginTop:"3rem"}}>
            <Card style={{ backgroundColor: "var(--green)", border: "none" }}>
              <div
               
                style={{ cursor: 'pointer', padding: '10px', margin: "auto", border: "2px solid var(--white)", boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px" }}
              >
                <img src={certif.cert} alt={certif.title} style={{ width: '100%', height: 'auto' }} />
              </div>

              </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Certificates;